export default {
  name: 'AbackToTop',
  methods: {
    click(a) {
      this.$emit('click', a);
      this.$emit('select', a);
    },
  },
  render() {
    const { visibilityHeight = 200, right = 40, bottom = 40, ...attrs } = this.$attrs;
    return (
      <el-backtop visibility-height={visibilityHeight} right={right} bottom={bottom} on-click={this.click} {...{ attrs }}>
        {this.$slots.default}
      </el-backtop>
    );
  }
}